export const model = {
    id: null,
    name: "",
    status: "",
    color: "",
    doctor_can: "",
    created_at: '',
    updated_at: ''
};
